import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropFertilizersMinerals, setFootprintingCropFertilizersMineralsAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP, FOOTPRINTING_CROP_FERTILIZERS_MINERAL } from "consts";

import { FootprintingCropFertilizer } from "models";

export const useMutateFootprintingCropFertilizersMinerals = (
  farmId: string,
  cropId: string,
  year: number,
  payload: FootprintingCropFertilizer[],
  primaryDataId: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingCropFertilizersMineralsAdmin : setFootprintingCropFertilizersMinerals;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_FERTILIZERS_MINERAL, primaryDataId],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_CROP_FERTILIZERS_MINERAL, primaryDataId],
          [FOOTPRINTING_CROP, farmId, cropId, year],
          [FOOTPRINTING_CROP, primaryDataId, isAdmin],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
